import { AIToolbarSection } from '../sections/markdown/AIToolbarSection';
import { CodeToolbarSection } from '../sections/markdown/CodeToolbarSection';
import { HeadingToolbarSection } from '../sections/markdown/HeadingToolbarSection';
import { HistoryToolbarSection } from '../sections/markdown/HistoryToolbarSection';
import { LinkToolbarSection } from '../sections/markdown/LinkToolbarSection';
import { ListStyleToolbarSection } from '../sections/markdown/ListStyleToolbarSection';
import { TextStyleToolbarSection } from '../sections/markdown/TextStyleToolbarSection';

import { ToolbarWrapper } from '../styles';

export const MarkdownToolBar = () => {
  return (
    <ToolbarWrapper>
      <TextStyleToolbarSection />
      <HeadingToolbarSection />
      <ListStyleToolbarSection />
      <CodeToolbarSection />
      <LinkToolbarSection />
      <AIToolbarSection />
      <HistoryToolbarSection />
    </ToolbarWrapper>
  );
};
